<template>
  <div data-component-group="layout" data-component="section-header">
    <div class="component-header">
      <v-tooltip top v-if="tooltipText">
        <template v-slot:activator="{ on, attrs }">
          <h2 v-bind="attrs" v-on="on">
            {{ title }}
            <v-icon 
              v-if="tooltipText"
              small 
              class="ml-1 material-icons-outlined"
            >
              info
            </v-icon>
          </h2>
        </template>
        <span>{{ tooltipText }}</span>
      </v-tooltip>
      <h2 v-else>
        {{ title }}
      </h2>

      <span class="header-right-text" v-if="titleRightText">{{ titleRightText }}</span>
      <v-btn v-if="hasTrigger" class="trigger elevation-0" @click="toggle" color="primary" outlined>
        {{ triggerLabel }}
      </v-btn>
      <slot name="right-side"></slot>
    </div>

    <p v-if="hasSubtitle" class="subtitle">
      {{ subtitle }}
    </p>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        required: true,
      },
      tooltipText: {
        type: String,
        default: null,
      },
      subtitle: {
        type: String,
        default: '',
      },
      titleRightText: {
        type: String,
        default: '',
      },
      hasTrigger: {
        type: Boolean,
        default: true,
      },
      triggerLabel: {
        type: String,
        default() {
          return this.$t('ok');
        },
      },
    },
    computed: {
      hasSubtitle() {
        return this.subtitle !== '';
      },
    },
    methods: {
      toggle() {
        this.$emit('toggle');
      },
    },
  };
</script>

<style lang="scss" scoped>
@import '../../assets/styles/theme';

[data-component-group='layout'][data-component='section-header'] {
  background-color: map-deep-get($colors, shades, 'white');
  padding: 0 0 $spacing-md 0;

  > .component-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    h2 {
      margin: 0;
      font-size: 18px;
      font-weight: 700;
    }

    .header-right-text {
      font-size: 12px;
      font-weight: 700;
    }
  }

  .v-btn {
    margin: 0;
    height: 30px;
    min-height: 30px;

    &:before {
      background-color: map-deep-get($colors, grey, base);
    }
  }
}
</style>
